import Icon from '@/components/ui/AppIcon';

interface InfoBoxItem {
  icon: string;
  title: string;
  description: string;
}

interface InfoBoxProps {
  title: string;
  items: InfoBoxItem[];
}

const InfoBox = ({ title, items }: InfoBoxProps) => {
  return (
    <div className="bg-accent/10 border-2 border-accent rounded-lg p-8 mb-12">
      <h3 className="font-heading text-2xl font-semibold text-primary mb-6">
        {title}
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {items.map((item, index) => (
          <div key={index} className="flex gap-4">
            <div className="flex-shrink-0">
              <div className="w-12 h-12 rounded-full bg-accent/20 flex items-center justify-center">
                <Icon name={item.icon as any} size={24} className="text-accent" />
              </div>
            </div>
            <div>
              <h4 className="font-body text-lg font-semibold text-primary mb-2">
                {item.title}
              </h4>
              <p className="font-body text-sm text-foreground/80 leading-relaxed">
                {item.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default InfoBox;